<div class="chat-driver-notes" [class.chat-driver-notes--locked]="locked">
  @if (showLabel) {
    <div class="chat-driver-notes__label" i18n="@@chatDriverNotesLabel">
      Do you want to add any Driver Notes?
      @if (isMandatory) {
        <span class="chat-driver-notes__required" aria-hidden="true">*</span>
      }
    </div>
  }

  <label class="chat-driver-notes__field-wrap">
    <textarea
      class="chat-driver-notes__control"
      aria-label="Driver notes"
      [(ngModel)]="notes"
      [maxlength]="maxLength"
      [disabled]="locked"
      rows="3"
      placeholder="Please add any special requests for the taxi provider or driver in here....for example passenger contact details for call on arrival, number of bags and if travelling with a wheelchair, is it manual or electric?"
    ></textarea>
    <span class="chat-driver-notes__counter">{{ notes.length }}/{{ maxLength }}</span>
  </label>

  @if (locked && chosenSummary) {
    <div class="chat-driver-notes__chosen">{{ chosenSummary }}</div>
  }

  <div class="chat-driver-notes__actions">
    <button
      type="button"
      class="chat-driver-notes__continue"
      [disabled]="locked || !isValid"
      (click)="onContinue()"
    >
      Continue
    </button>
  </div>
</div>
